export const REDIRECT_MODAL_CANCEL_TEST_ID = 'RedirectModalCancelButton';
export const REDIRECT_MODAL_CONTINUE_TEST_ID = 'RedirectModalContinueButton';
